import { getSecurityPrefs } from "../vault/prefs";

// Copy to clipboard and auto-clear after the configured delay (§20).
export function copyEphemeral(value: string) {
  if (!value) return;
  navigator.clipboard.writeText(value).catch(() => undefined);
  // Clear the clipboard after the configured delay (§20), read fresh so a settings change applies.
  setTimeout(() => {
    navigator.clipboard.writeText("").catch(() => undefined);
  }, getSecurityPrefs().clipboardClearSec * 1000);
}
